import { IconButton, Paper, Snackbar } from '@mui/material'
import React from 'react'
import NearMeIcon from '@mui/icons-material/NearMe'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import maplibregl from 'maplibre-gl'

export const CurrentLocationControl = () => {
  const state = useGlobalState()
  const [snackbar, setSnackbar] = React.useState<string | null>(null)
  const [marker, setMarker] = React.useState<maplibregl.Marker | null>(null)

  const getCurrentPosition = () => {
    if (!navigator.geolocation) {
      setSnackbar('お使いのブラウザでは現在地情報を利用できない可能性があります。')
      return
    }
    const options = {
      enableHighAccuracy: false,
      timeout: 5 * 1000,
      maximumAge: 0
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (!state.mapbox) return
        const lngLat = new maplibregl.LngLat(position.coords.longitude, position.coords.latitude)
        if (marker === null) {
          const createdMarker = new maplibregl.Marker()
          createdMarker
            .setLngLat(lngLat)
            .addTo(state.mapbox)
          setMarker(createdMarker)
        } else {
          marker.setLngLat(lngLat)
        }
        state.mapbox.flyTo({center: lngLat, zoom: 16})
      },
      (err) => {
        switch (err.code) {
        case 1: // PERMISSION_DENIED
          setSnackbar('ブラウザで位置情報の取得が許可されていません。')
          break
        case 2: // POSITION_UNAVAILABLE
          setSnackbar('位置情報が取得できませんでした。')
          break
        case 3: // TIMEOUT
          setSnackbar('位置情報の取得中にタイムアウトしました。')
          break
        default:
          setSnackbar(err.message)
        }
      },
      options
    )
  }

  return (
    <>
      <Paper sx={{pointerEvents: 'painted', backgroundColor: '#37474f', width: 30}}>
        <IconButton size="small" sx={{color: grey[50]}} onClick={getCurrentPosition}>
          <NearMeIcon sx={{width: 18, height: 18}} />
        </IconButton>
      </Paper>
      <Snackbar
        open={snackbar !== null}
        onClose={() => setSnackbar(null)}
        message={snackbar}
        autoHideDuration={5000}
        anchorOrigin={{horizontal: 'center', vertical: 'top'}}
        sx={{
          top: '50% !important',
          transform: 'translateY(-50%)',
        }}
      />
    </>
  )
}
